// @flow
import type { ActionsState } from '~/core/state/actions/types';

import { connect } from 'react-redux';
import { getHasEntitlement } from '~/core/state/entitlements/selectors';
import { getWhetherDeviceHasCapability } from '~/core/state/devices/selectors';
import { showHiveLiveModal } from '~/core/state/application/actions';
import { talkToLight } from '~/core/state/products/bulbs/actions';
import { capabilities } from '~/core/constants/devices';
import Component from './component';

const mapStateToProps = (state: { actions: ActionsState }) => {
    const hasSMS = getHasEntitlement(state, 'SMS');

    return { hasSMS, checkCapability: props => getWhetherDeviceHasCapability(state, props) };
};

const mapDispatchToProps = {
    showHiveLiveModal,
    talkToLight
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { checkCapability } = stateProps;
    const { talkToLight } = dispatchProps;
    const { setActionAttribute } = ownProps;

    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        setActionAttribute: (prop, newVal) => {
            if (prop === 'id' && newVal) {
                const hasIdentifyDeviceCapabilitiy = checkCapability({
                    id: newVal,
                    capabilityName: capabilities.IDENTIFY_DEVICE
                });

                hasIdentifyDeviceCapabilitiy &&
                    talkToLight({
                        id: newVal,
                        patch: {
                            identifyMode: true
                        }
                    });
            }

            return setActionAttribute(prop, newVal);
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Component);



// WEBPACK FOOTER //
// ./src/components/widgets/actions/action-attribute/index.js